/* eslint-disable @typescript-eslint/dot-notation */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/no-use-before-define */
/* eslint-disable react/prop-types */
import { Text } from "@mantine/core";
import { ICellTextProps } from "ka-table/props";
import React from "react";
import uuid from "react-uuid";

/**
 * Custom cell component.
 */
const IconsGroupCell: React.FC<ICellTextProps> = React.memo(
  ({
    column, dispatch, rowKeyValue, ...props
  }) => {
    const value = props.rowData[`${column.key}`] || [];
    const maxToShow = 3;
    const visible = value.slice(0, maxToShow);
    const remaining = value.length - maxToShow;

    return (
      <div className="flex flex-row flex-wrap gap-1 items-center text-gray-400">
        {visible.map((item: any, index: number) => (
          <React.Fragment key={uuid()}>
            <item.Icon className="h-[17px] w-[17px] hover:scale-110" />
            <Text className="text-xs font-semibold text-gray-700" c="text.5">
              {item.name}
              {index !== visible.length - 1 && (
                <Text span className="mx-1">&</Text>
              )}
            </Text>
          </React.Fragment>
        ))}
        {remaining > 0 && (
          <Text className="text-xs font-semibold text-gray-700">{`+${remaining} more`}</Text>
        )}
      </div>
    );
  },
);
export default IconsGroupCell;
